const Index = () => import(/* webpackChunkName: "support" */ '@/components/support/index')
export default {
    name: 'support',
    path: 'support',
    redirect: '/support/index',
    meta: {label: 'support'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index'},
            component: Index,
            props: true
        }
    ]
}
